var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('Navbar')],1),_c('main',[_c('router-view',{key:_vm.$route.path})],1),_c('cxt-Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }